import React, { useState, useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import './ProductsSection.css';

const ProductsSection = ({ showKlaviyoForm, showInvestorInquiryForm, onNavigateToLogin }) => {
  const [swiper, setSwiper] = useState(null);
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  return (
  <section >
    {/* Trust Section */}
    <div className="trust-section container mt-5">
      <h2 className="trust-title">Built by Clinicians. <b>Trusted by Thousands.</b></h2>
      <div className="trust-content">
        <div className="trust-visuals">
          <div className="trust-image-grid">
            <div className="trust-image">
              <img src="/11.png" alt="Medical professional with monitors" />
            </div>
            <div className="trust-image">
              <img src="/21.png" alt="Medical presentation"/>
            </div>
            <div className="trust-image">
              <img src="/12.png" alt="Medical team collaboration"/>
            </div>
            <div className="trust-image">
              <img src="/22.png" alt="Medical professional with phone"/>
            </div>
          </div>
        </div>
        <div className="trust-features">
          <div className="trust-feature">
            <div className="trust-feature-icon"><svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_900_17658)"><path d="M23.75 0H6.25C4.59301 0.00198482 3.00445 0.661102 1.83277 1.83277C0.661102 3.00445 0.00198482 4.59301 0 6.25L0 23.75C0.00198482 25.407 0.661102 26.9956 1.83277 28.1672C3.00445 29.3389 4.59301 29.998 6.25 30H23.75C25.407 29.998 26.9956 29.3389 28.1672 28.1672C29.3389 26.9956 29.998 25.407 30 23.75V6.25C29.998 4.59301 29.3389 3.00445 28.1672 1.83277C26.9956 0.661102 25.407 0.00198482 23.75 0V0ZM27.5 23.75C27.5 24.7446 27.1049 25.6984 26.4017 26.4017C25.6984 27.1049 24.7446 27.5 23.75 27.5H6.25C5.25544 27.5 4.30161 27.1049 3.59835 26.4017C2.89509 25.6984 2.5 24.7446 2.5 23.75V6.25C2.5 5.25544 2.89509 4.30161 3.59835 3.59835C4.30161 2.89509 5.25544 2.5 6.25 2.5H23.75C24.7446 2.5 25.6984 2.89509 26.4017 3.59835C27.1049 4.30161 27.5 5.25544 27.5 6.25V23.75Z" fill="#0F4ABE"/><path d="M11.666 19.8987L6.76727 15C6.53286 14.7657 6.21498 14.634 5.88352 14.634C5.55207 14.634 5.23418 14.7657 4.99977 15C4.76543 15.2344 4.63379 15.5523 4.63379 15.8837C4.63379 16.2152 4.76543 16.5331 4.99977 16.7675L9.89852 21.6662C10.1307 21.8985 10.4063 22.0827 10.7097 22.2084C11.0131 22.3341 11.3383 22.3988 11.6666 22.3988C11.995 22.3988 12.3202 22.3341 12.6236 22.2084C12.927 22.0827 13.2026 21.8985 13.4348 21.6662L24.9998 10.1013C25.2341 9.86684 25.3658 9.54896 25.3658 9.2175C25.3658 8.88605 25.2341 8.56816 24.9998 8.33376C24.7654 8.09942 24.4475 7.96777 24.116 7.96777C23.7846 7.96777 23.4667 8.09942 23.2323 8.33376L11.666 19.8987Z" fill="#0C3B98"/></g><defs><clipPath id="clip0_900_17658"><rect width="30" height="30" fill="white"/></clipPath></defs></svg>
            </div>
            <div className="trust-feature-text">Built by clinicians, for clinicians.</div>
          </div>
          <div className="trust-feature-border"></div>
          <div className="trust-feature">
            <div className="trust-feature-icon"><svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_900_25334)"><path d="M28.75 13.7507H26.25V11.2507C26.25 10.9192 26.1183 10.6013 25.8839 10.3668C25.6495 10.1324 25.3315 10.0007 25 10.0007C24.6685 10.0007 24.3505 10.1324 24.1161 10.3668C23.8817 10.6013 23.75 10.9192 23.75 11.2507V13.7507H21.25C20.9185 13.7507 20.6005 13.8824 20.3661 14.1168C20.1317 14.3513 20 14.6692 20 15.0007C20 15.3322 20.1317 15.6502 20.3661 15.8846C20.6005 16.119 20.9185 16.2507 21.25 16.2507H23.75V18.7507C23.75 19.0822 23.8817 19.4002 24.1161 19.6346C24.3505 19.869 24.6685 20.0007 25 20.0007C25.3315 20.0007 25.6495 19.869 25.8839 19.6346C26.1183 19.4002 26.25 19.0822 26.25 18.7507V16.2507H28.75C29.0815 16.2507 29.3994 16.119 29.6339 15.8846C29.8683 15.6502 30 15.3322 30 15.0007C30 14.6692 29.8683 14.3513 29.6339 14.1168C29.3994 13.8824 29.0815 13.7507 28.75 13.7507Z" fill="#0F4ABE"/><path d="M11.25 15C12.7334 15 14.1834 14.5601 15.4168 13.736C16.6501 12.9119 17.6114 11.7406 18.1791 10.3701C18.7468 8.99968 18.8953 7.49168 18.6059 6.03683C18.3165 4.58197 17.6022 3.2456 16.5533 2.1967C15.5044 1.14781 14.168 0.433503 12.7132 0.144114C11.2583 -0.145275 9.75032 0.00324965 8.37987 0.570907C7.00943 1.13856 5.83809 2.09986 5.01398 3.33323C4.18987 4.5666 3.75 6.01664 3.75 7.5C3.75199 9.48852 4.5428 11.395 5.94889 12.8011C7.35499 14.2072 9.26149 14.998 11.25 15ZM11.25 2.5C12.2389 2.5 13.2056 2.79325 14.0279 3.34266C14.8501 3.89206 15.491 4.67296 15.8694 5.58659C16.2478 6.50022 16.3469 7.50555 16.1539 8.47546C15.961 9.44536 15.4848 10.3363 14.7855 11.0355C14.0863 11.7348 13.1954 12.211 12.2255 12.4039C11.2555 12.5969 10.2502 12.4978 9.33658 12.1194C8.42295 11.741 7.64206 11.1001 7.09265 10.2779C6.54324 9.45561 6.25 8.48891 6.25 7.5C6.25 6.17392 6.77678 4.90215 7.71447 3.96447C8.65215 3.02679 9.92392 2.5 11.25 2.5Z" fill="#0F4ABE"/><path d="M11.25 17.5007C8.26733 17.504 5.40777 18.6904 3.2987 20.7994C1.18964 22.9085 0.00330857 25.7681 0 28.7507C0 29.0823 0.131696 29.4002 0.366117 29.6346C0.600537 29.869 0.918479 30.0007 1.25 30.0007C1.58152 30.0007 1.89946 29.869 2.13388 29.6346C2.3683 29.4002 2.5 29.0823 2.5 28.7507C2.5 26.4301 3.42187 24.2045 5.06282 22.5635C6.70376 20.9226 8.92936 20.0007 11.25 20.0007C13.5706 20.0007 15.7962 20.9226 17.4372 22.5635C19.0781 24.2045 20 26.4301 20 28.7507C20 29.0823 20.1317 29.4002 20.3661 29.6346C20.6005 29.869 20.9185 30.0007 21.25 30.0007C21.5815 30.0007 21.8995 29.869 22.1339 29.6346C22.3683 29.4002 22.5 29.0823 22.5 28.7507C22.4967 25.7681 21.3104 22.9085 19.2013 20.7994C17.0922 18.6904 14.2327 17.504 11.25 17.5007Z" fill="#0F4ABE"/></g><defs><clipPath id="clip0_900_25334"><rect width="30" height="30" fill="white"/></clipPath></defs></svg>
            </div>
            <div className="trust-feature-text">Role-aware answers for doctors and allied health professionals.</div>
          </div>
          <div className="trust-feature-border"></div>
          <div className="trust-feature">
              <div className="trust-feature-icon"><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M30.5627 2.26659C30.1137 1.89023 29.5871 1.61764 29.0206 1.46829C28.454 1.31894 27.8615 1.29651 27.2853 1.40259L19.0453 2.89992C17.8662 3.11253 16.7933 3.71665 16 4.61459C15.2073 3.71517 14.1343 3.1096 12.9547 2.89592L4.71467 1.39859C4.13836 1.29394 3.5461 1.31713 2.97974 1.46653C2.41338 1.61593 1.88674 1.88789 1.43704 2.2632C0.987341 2.6385 0.62555 3.10798 0.377235 3.63848C0.128921 4.16897 0.000142327 4.74752 0 5.33326L0 27.7786L16 30.6893L32 27.7786V5.33326C32.0001 4.74795 31.8713 4.1698 31.6229 3.63982C31.3745 3.10984 31.0125 2.64101 30.5627 2.26659ZM14.6667 27.7333L2.66667 25.5546V5.33326C2.66683 5.13804 2.70986 4.94525 2.79272 4.76849C2.87557 4.59173 2.99623 4.43532 3.14616 4.31031C3.2961 4.1853 3.47166 4.09473 3.66044 4.04502C3.84921 3.9953 4.04661 3.98765 4.23867 4.02259L12.4773 5.51992C13.0918 5.63171 13.6475 5.95561 14.0476 6.43513C14.4477 6.91466 14.6668 7.5194 14.6667 8.14392V27.7333ZM29.3333 25.5519L17.3333 27.7333V8.14392C17.3332 7.5194 17.5523 6.91466 17.9524 6.43513C18.3525 5.95561 18.9082 5.63171 19.5227 5.51992L27.7613 4.02259C27.9534 3.98765 28.1508 3.9953 28.3396 4.04502C28.5283 4.09473 28.7039 4.1853 28.8538 4.31031C29.0038 4.43532 29.1244 4.59173 29.2073 4.76849C29.2901 4.94525 29.3332 5.13804 29.3333 5.33326V25.5519Z" fill="#0F4ABE"/></svg>
            </div>
            <div className="trust-feature-text">Powered by decades of trusted, peer-reviewed NYSORA content.</div>
          </div>
          <div className="trust-feature-border"></div>
          <div className="trust-feature">
            <div className="trust-feature-icon"><svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_900_25335)"><path d="M14.2083 17.7255C13.8158 17.5015 13.4896 17.1776 13.2626 16.7867C13.0357 16.3959 12.9162 15.952 12.9162 15.5C12.9162 15.048 13.0357 14.6041 13.2626 14.2133C13.4896 13.8224 13.8158 13.4985 14.2083 13.2745V9.04167C14.2083 8.69909 14.3444 8.37055 14.5867 8.12832C14.8289 7.88609 15.1574 7.75 15.5 7.75C15.8426 7.75 16.1711 7.88609 16.4133 8.12832C16.6556 8.37055 16.7917 8.69909 16.7917 9.04167V13.2745C17.1842 13.4985 17.5104 13.8224 17.7374 14.2133C17.9643 14.6041 18.0838 15.048 18.0838 15.5C18.0838 15.952 17.9643 16.3959 17.7374 16.7867C17.5104 17.1776 17.1842 17.5015 16.7917 17.7255V20.6667C16.7917 21.0092 16.6556 21.3378 16.4133 21.58C16.1711 21.8222 15.8426 21.9583 15.5 21.9583C15.1574 21.9583 14.8289 21.8222 14.5867 21.58C14.3444 21.3378 14.2083 21.0092 14.2083 20.6667V17.7255ZM15.5 0C15.1574 0 14.8289 0.136086 14.5867 0.37832C14.3444 0.620555 14.2083 0.949095 14.2083 1.29167C14.2083 1.63424 14.3444 1.96278 14.5867 2.20501C14.8289 2.44725 15.1574 2.58333 15.5 2.58333C18.9257 2.58333 22.2111 3.94419 24.6335 6.36654C27.0558 8.78888 28.4167 12.0743 28.4167 15.5C28.4167 18.9257 27.0558 22.2111 24.6335 24.6335C22.2111 27.0558 18.9257 28.4167 15.5 28.4167C15.1574 28.4167 14.8289 28.5528 14.5867 28.795C14.3444 29.0372 14.2083 29.3658 14.2083 29.7083C14.2083 30.0509 14.3444 30.3794 14.5867 30.6217C14.8289 30.8639 15.1574 31 15.5 31C19.6109 31 23.5533 29.367 26.4602 26.4602C29.367 23.5533 31 19.6109 31 15.5C31 11.3891 29.367 7.44666 26.4602 4.53984C23.5533 1.63303 19.6109 0 15.5 0V0ZM2.35988 8.76267C2.10441 8.76267 1.85468 8.83842 1.64226 8.98035C1.42985 9.12228 1.26429 9.32401 1.16653 9.56003C1.06877 9.79605 1.04319 10.0558 1.09303 10.3063C1.14287 10.5569 1.26589 10.787 1.44653 10.9677C1.62717 11.1483 1.85733 11.2713 2.10788 11.3212C2.35844 11.371 2.61815 11.3454 2.85417 11.2477C3.0902 11.1499 3.29193 10.9844 3.43386 10.7719C3.57579 10.5595 3.65154 10.3098 3.65154 10.0543C3.65154 9.71176 3.51546 9.38322 3.27322 9.14099C3.03099 8.89875 2.70245 8.76267 2.35988 8.76267ZM2.58333 15.5C2.58333 15.2445 2.50758 14.9948 2.36565 14.7824C2.22372 14.57 2.02199 14.4044 1.78597 14.3067C1.54995 14.2089 1.29023 14.1833 1.03968 14.2332C0.789117 14.283 0.558964 14.406 0.378321 14.5867C0.197678 14.7673 0.0746588 14.9974 0.0248196 15.248C-0.0250196 15.4986 0.000559655 15.7583 0.0983228 15.9943C0.196086 16.2303 0.361642 16.4321 0.574056 16.574C0.786469 16.7159 1.0362 16.7917 1.29167 16.7917C1.63424 16.7917 1.96278 16.6556 2.20501 16.4133C2.44725 16.1711 2.58333 15.8426 2.58333 15.5ZM5.45213 4.14237C5.19666 4.14237 4.94693 4.21813 4.73451 4.36006C4.5221 4.50199 4.35654 4.70372 4.25878 4.93974C4.16102 5.17576 4.13544 5.43547 4.18528 5.68603C4.23512 5.93659 4.35814 6.16675 4.53878 6.34739C4.71942 6.52803 4.94958 6.65105 5.20013 6.70089C5.45069 6.75073 5.7104 6.72515 5.94642 6.62739C6.18245 6.52962 6.38418 6.36407 6.52611 6.15165C6.66804 5.93924 6.74379 5.68951 6.74379 5.43404C6.74379 5.09147 6.60771 4.76293 6.36547 4.5207C6.12324 4.27846 5.7947 4.14237 5.45213 4.14237ZM10.0479 1.08629C9.79241 1.08629 9.54268 1.16205 9.33026 1.30398C9.11785 1.44591 8.95229 1.64764 8.85453 1.88366C8.75677 2.11968 8.73119 2.37939 8.78103 2.62995C8.83087 2.88051 8.95389 3.11066 9.13453 3.2913C9.31517 3.47195 9.54532 3.59497 9.79588 3.64481C10.0464 3.69464 10.3062 3.66907 10.5422 3.5713C10.7782 3.47354 10.9799 3.30798 11.1219 3.09557C11.2638 2.88316 11.3395 2.63343 11.3395 2.37796C11.3395 2.03539 11.2035 1.70685 10.9612 1.46461C10.719 1.22238 10.3904 1.08629 10.0479 1.08629ZM2.35988 19.654C2.10441 19.654 1.85468 19.7298 1.64226 19.8717C1.42985 20.0136 1.26429 20.2153 1.16653 20.4514C1.06877 20.6874 1.04319 20.9471 1.09303 21.1977C1.14287 21.4482 1.26589 21.6784 1.44653 21.859C1.62717 22.0397 1.85733 22.1627 2.10788 22.2125C2.35844 22.2624 2.61815 22.2368 2.85417 22.139C3.0902 22.0412 3.29193 21.8757 3.43386 21.6633C3.57579 21.4509 3.65154 21.2011 3.65154 20.9457C3.65154 20.6031 3.51546 20.2746 3.27322 20.0323C3.03099 19.7901 2.70245 19.654 2.35988 19.654ZM5.45213 24.2743C5.19666 24.2743 4.94693 24.35 4.73451 24.492C4.5221 24.6339 4.35654 24.8356 4.25878 25.0717C4.16102 25.3077 4.13544 25.5674 4.18528 25.8179C4.23512 26.0685 4.35814 26.2987 4.53878 26.4793C4.71942 26.6599 4.94958 26.783 5.20013 26.8328C5.45069 26.8826 5.7104 26.8571 5.94642 26.7593C6.18245 26.6615 6.38418 26.496 6.52611 26.2836C6.66804 26.0712 6.74379 25.8214 6.74379 25.566C6.74379 25.2234 6.60771 24.8948 6.36547 24.6526C6.12324 24.4104 5.7947 24.2743 5.45213 24.2743ZM10.0479 27.3304C9.79241 27.3304 9.54268 27.4061 9.33026 27.5481C9.11785 27.69 8.95229 27.8917 8.85453 28.1277C8.75677 28.3638 8.73119 28.6235 8.78103 28.874C8.83087 29.1246 8.95389 29.3547 9.13453 29.5354C9.31517 29.716 9.54532 29.8391 9.79588 29.8889C10.0464 29.9387 10.3062 29.9131 10.5422 29.8154C10.7782 29.7176 10.9799 29.5521 11.1219 29.3397C11.2638 29.1272 11.3395 28.8775 11.3395 28.622C11.3395 28.2795 11.2035 27.9509 10.9612 27.7087C10.719 27.4665 10.3904 27.3304 10.0479 27.3304Z" fill="#0F4ABE"/></g><defs><clipPath id="clip0_900_25335"><rect width="31" height="31" fill="white"/></clipPath></defs></svg>
            </div>
            <div className="trust-feature-text">Designed for real-time use – in the OR, at the bedside, anywhere care happens.</div>
          </div>
        </div>
      </div>
    </div>

    <div id="globalimpact" className='dotsmap container-fluid d-flex justify-content-center mt-5'>
      <div className='mapka-map-image-wrapper container row d-flex justify-content-center justify-content-xl-start align-items-center'>
        <div className='mapka-map-overlay-text col-10 col-xl-4'>
          <div className='mb-4'>
          <svg width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_900_33393)"><path d="M23.5 0C18.8521 0 14.3087 1.37825 10.4441 3.96046C6.57955 6.54268 3.5675 10.2129 1.78884 14.5069C0.0101822 18.801 -0.455196 23.5261 0.451556 28.0846C1.35831 32.6432 3.59647 36.8305 6.883 40.117C10.1695 43.4035 14.3568 45.6417 18.9154 46.5485C23.4739 47.4552 28.199 46.9898 32.4931 45.2112C36.7871 43.4325 40.4573 40.4205 43.0395 36.5559C45.6218 32.6913 47 28.1479 47 23.5C46.9933 17.2695 44.5152 11.2961 40.1096 6.89043C35.7039 2.48479 29.7305 0.00673878 23.5 0V0ZM43.0833 23.5C43.0857 27.3378 41.9533 31.0906 39.8286 34.2865L37.4943 31.9502C37.3112 31.7667 37.2084 31.5181 37.2083 31.2589V29.375C37.2083 27.8169 36.5894 26.3225 35.4876 25.2207C34.3858 24.119 32.8915 23.5 31.3333 23.5H25.4583C24.939 23.5 24.4409 23.2937 24.0736 22.9264C23.7063 22.5592 23.5 22.0611 23.5 21.5417V20.5625C23.5 20.3028 23.6032 20.0538 23.7868 19.8701C23.9704 19.6865 24.2195 19.5833 24.4792 19.5833C25.7776 19.5833 27.0229 19.0675 27.9411 18.1494C28.8592 17.2312 29.375 15.986 29.375 14.6875V12.7292C29.375 12.4695 29.4782 12.2204 29.6618 12.0368C29.8454 11.8532 30.0945 11.75 30.3542 11.75H33.0547C34.3519 11.7463 35.5953 11.2312 36.5151 10.3165L37.2534 9.57821C39.1005 11.3957 40.5672 13.5627 41.5682 15.9529C42.5691 18.3431 43.0842 20.9087 43.0833 23.5ZM4.01264 25.3859L10.1971 31.5703C10.7413 32.118 11.3889 32.5522 12.1022 32.8477C12.8156 33.1432 13.5805 33.2941 14.3526 33.2917H19.5833C20.1027 33.2917 20.6008 33.498 20.9681 33.8652C21.3354 34.2325 21.5417 34.7306 21.5417 35.25V42.9835C17.0379 42.5237 12.8318 40.5202 9.63683 37.3128C6.44187 34.1053 4.45479 29.8914 4.01264 25.3859ZM25.4583 42.9835V35.25C25.4583 33.6919 24.8394 32.1975 23.7376 31.0957C22.6358 29.994 21.1415 29.375 19.5833 29.375H14.3526C14.0952 29.3752 13.8402 29.3246 13.6022 29.2262C13.3643 29.1277 13.1482 28.9833 12.9661 28.8012L4.23589 20.071C4.79631 16.8851 6.13887 13.8883 8.1431 11.3493C10.1473 8.81028 12.7505 6.80855 15.7192 5.5237C18.6878 4.23885 21.9289 3.71107 25.1518 3.98772C28.3747 4.26436 31.4785 5.33678 34.1847 7.10875L33.746 7.54742C33.5617 7.72921 33.3136 7.8318 33.0547 7.83333H30.3542C29.0557 7.83333 27.8104 8.34914 26.8923 9.26729C25.9742 10.1854 25.4583 11.4307 25.4583 12.7292V14.6875C25.4583 14.9472 25.3552 15.1962 25.1716 15.3799C24.9879 15.5635 24.7389 15.6667 24.4792 15.6667C23.1807 15.6667 21.9354 16.1825 21.0173 17.1006C20.0992 18.0188 19.5833 19.264 19.5833 20.5625V21.5417C19.5833 23.0998 20.2023 24.5941 21.3041 25.6959C22.4059 26.7977 23.9002 27.4167 25.4583 27.4167H31.3333C31.8527 27.4167 32.3508 27.623 32.7181 27.9903C33.0854 28.3575 33.2917 28.8556 33.2917 29.375V31.2589C33.2954 32.5561 33.8105 33.7995 34.7252 34.7193L37.3435 37.3376C34.1542 40.5379 29.9539 42.5332 25.4583 42.9835Z" fill="white"/></g><defs><clipPath id="clip0_900_33393"><rect width="47" height="47" fill="white"/></clipPath></defs></svg>
          </div>
          <div className='mapka-map-overlay-title'>Global Impact</div>
          <div className='mapka-map-overlay-desc'>MAIA's mission is simple: Empower clinicians <br/> with Intelligent Clinical Support at the Point of Care to improve safety and patient outcomes. Delivering real-time information guidance - exactly when and where it’s needed most.</div>
        </div>
      </div>
    </div>

    {/* Partners Section */}
    <div className="partners-section container mt-5">
      <h2 className="partners-title">Global Clinical Collaborators</h2>
      <div className="partners-swiper-container">
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={30}
          slidesPerView={5}
          pagination={{
            clickable: true,
            el: '.swiper-pagination',
          }}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          loop={true}
          breakpoints={{
            320: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            480: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 30,
            },
            1200: {
              slidesPerView: 5,
              spaceBetween: 30,
            },
          }}
          className="partners-swiper"
        >
          <SwiperSlide>
            <div className="partner-logo">
              <img src="/grid_images/nysoragrid.png" alt="Nysora" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="partner-logo">
              <img src="/grid_images/abudhabigrid.png" alt="CCAD" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="partner-logo">
              <img src="/grid_images/grid13.png" alt="Partner Name" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="partner-logo">
              <img src="/grid_images/grid14.png" alt="Partner Name" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="partner-logo">
              <img src="/grid_images/grid21.png" alt="Partner Name" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="partner-logo">
              <img src="/grid_images/grid22.png" alt="Partner Name" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="partner-logo">
              <img src="/grid_images/grid23.png" alt="Partner Name" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="partner-logo">
              <img src="/grid_images/grid24.png" alt="Partner Name" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="partner-logo">
              <img src="/grid_images/grid31.png" alt="Partner Name" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="partner-logo">
              <img src="/grid_images/grid32.png" alt="Partner Name" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="partner-logo">
              <img src="/grid_images/grid33.png" alt="Partner Name" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="partner-logo">
              <img src="/grid_images/grid34.png" alt="Partner Name" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="partner-logo">
              <img src="/grid_images/grid41.png" alt="Partner Name" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="partner-logo">
              <img src="/grid_images/grid42.png" alt="Partner Name" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="partner-logo">
              <img src="/grid_images/grid43.png" alt="Partner Name" />
            </div>
          </SwiperSlide>
        </Swiper>
        <div className="swiper-pagination"></div>
      </div>
    </div>

    {/* Testimonials Section */}
    <div className="testimonials-section container-fluid mt-5">
      <h2 className="testimonials-title">Trusted by Doctors Around the World</h2>
      <div className="testimonials-container">
        <div className="testimonials-quote-icon">
          <svg width="119" height="104" viewBox="0 0 119 104" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.540039 96.8311V41.8018C0.540039 29.3831 4.75553 19.7559 13.1865 12.9199C21.6175 5.97005 33.6374 1.69759 49.2461 0.102539V26.9336C40.1315 28.1868 33.1247 30.5225 28.2256 33.9404C23.3265 37.3584 20.0794 42.1436 18.4844 48.2959H49.2461V96.8311H0.540039ZM118.289 6.59668V61.626C118.289 74.0446 114.074 83.7288 105.643 90.6787C97.2116 97.5146 85.1917 101.73 69.583 103.325V76.4941C78.6976 75.2409 85.7044 72.9053 90.6035 69.4873C95.5026 66.0693 98.7497 61.2842 100.345 55.1318H69.583V6.59668H118.289Z" fill="#C8C8C8"/>
          </svg>
        </div>
        
        <Swiper
          modules={[Pagination, Autoplay, Navigation]}
          spaceBetween={30}
          slidesPerView={1}
          pagination={{
            clickable: true,
            el: '.testimonials-pagination',
          }}
          navigation={{
            nextEl: nextRef.current,
            prevEl: prevRef.current,
          }}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          loop={true}
          className="testimonials-swiper"

        >
          <SwiperSlide>
            <div className="testimonial-card">
              <div className="testimonial-header">
                <div className="testimonial-profile">
                  <img src="https://plus.unsplash.com/premium_photo-1689530775582-83b8abdb5020?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8cmFuZG9tJTIwcGVyc29ufGVufDB8fDB8fHww" alt="Dr. John Doe" className="testimonial-avatar" />
                </div>
                <div className="testimonial-rating">
                  <div className="rating-score">5.0 / 5</div>
                  <div className="rating-stars">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75492L10 0Z"/>
                    </svg>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75492L10 0Z"/>
                    </svg>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75492L10 0Z"/>
                    </svg>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75492L10 0Z"/>
                    </svg>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75492L10 0Z"/>
                    </svg>
                  </div>
                </div>
              </div>
              <div className="testimonial-name">Dr. John Doe</div>
              <div className="testimonial-text">
                "MAIA has revolutionized how I approach patient care. The instant access to evidence-based information has significantly improved my decision-making process and patient outcomes."
              </div>
            </div>
          </SwiperSlide>
          
          <SwiperSlide>
            <div className="testimonial-card">
              <div className="testimonial-header">
                <div className="testimonial-profile">
                  <img src="https://plus.unsplash.com/premium_photo-1689551670902-19b441a6afde?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8cmFuZG9tJTIwcGVvcGxlfGVufDB8fDB8fHww" alt="Dr. Sarah Johnson" className="testimonial-avatar" />
                </div>
                <div className="testimonial-rating">
                  <div className="rating-score">5.0 / 5</div>
                  <div className="rating-stars">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75492L10 0Z"/>
                    </svg>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75492L10 0Z"/>
                    </svg>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75492L10 0Z"/>
                    </svg>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75492L10 0Z"/>
                    </svg>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75492L10 0Z"/>
                    </svg>
                  </div>
                </div>
              </div>
              <div className="testimonial-name">Dr. Sarah Johnson</div>
              <div className="testimonial-text">
                "The role-aware responses and real-time support have made a tremendous difference in my practice. MAIA truly understands the needs of healthcare professionals."
              </div>
            </div>
          </SwiperSlide>
          
          <SwiperSlide>
            <div className="testimonial-card">
              <div className="testimonial-header">
                <div className="testimonial-profile">
                  <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8cmFuZG9tJTIwcGVvcGxlfGVufDB8fDB8fHww" alt="Dr. Michael Chen" className="testimonial-avatar" />
                </div>
                <div className="testimonial-rating">
                  <div className="rating-score">5.0 / 5</div>
                  <div className="rating-stars">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75492L10 0Z"/>
                    </svg>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75492L10 0Z"/>
                    </svg>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75492L10 0Z"/>
                    </svg>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75492L10 0Z"/>
                    </svg>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75492L10 0Z"/>
                    </svg>
                  </div>
                </div>
              </div>
              <div className="testimonial-name">Dr. Michael Chen</div>
              <div className="testimonial-text">
                "Having access to decades of peer-reviewed NYSORA content at my fingertips has transformed my clinical practice. MAIA is the future of medical decision support."
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
        
        <div className="testimonials-pagination"></div>
        
        {/* Navigation Arrows */}
        <div ref={prevRef} className="testimonials-button-prev">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z" fill="#9CA3AF"/>
          </svg>
        </div>
        <div ref={nextRef} className="testimonials-button-next">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.59 16.59L10 18L16 12L10 6L8.59 7.41L13.17 12L8.59 16.59Z" fill="#9CA3AF"/>
          </svg>
        </div>
      </div>
    </div>

    {/* Early Access Hero Section */}
    <div className="container-fluid" style={{ 
      position: 'relative',
      background: 'linear-gradient(270deg, rgba(15, 74, 190, 0.85) 0%, rgba(7, 34, 88, 0.85) 100%), url("/gifbg.gif")',
      backgroundSize: 'cover, cover',
      backgroundPosition: 'center, center',
      backgroundRepeat: 'no-repeat, no-repeat',
      padding: '60px 40px',
      overflow: 'hidden'
    }}>
      {/* Background Pattern */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'radial-gradient(circle at 20% 30%, rgba(255,255,255,0.1) 0%, transparent 50%), radial-gradient(circle at 80% 70%, rgba(255,255,255,0.08) 0%, transparent 50%)',
        pointerEvents: 'none'
      }}></div>
      
      <div className="early-access-content" style={{ position: 'relative', zIndex: 2 }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <img src="/maiawhiteicon.svg" alt="MAIA Logo" />
        </div>
        
        {/* Main Title */}
        <div style={{ textAlign: 'center', marginBottom: '40px', marginTop: '40px' }}>
          <h2 style={{
            color: 'white',
            fontSize: '32px',
            fontWeight: '700',
            margin: 0,
            lineHeight: '1.2'
          }}>
            Join the Next Generation of Clinical AI
          </h2>
        </div>
        
        {/* Buttons */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          gap: '20px',
          flexWrap: 'wrap',
          marginTop: '40px',
          marginBottom: '40px'
        }}>
          <button 
            className="early-access-btn primary" 
            onClick={showKlaviyoForm}
            style={{
              background: 'white',
              color: '#0C3B98',
              border: '2px solid #0C3B98',
              borderRadius: '100px',
              padding: '12px 30px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
          >
            Join the Waitlist
          </button>
          <button 
            className="early-access-btn secondary" 
            onClick={showInvestorInquiryForm}
            style={{
              background: 'transparent',
              color: 'white',
              border: '2px solid white',
              borderRadius: '100px',
              padding: '12px 60px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = 'white';
              e.target.style.color = '#0C3B98';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'transparent';
              e.target.style.color = 'white';
            }}
          >
            Investor Inquiry
          </button>
        </div>
      </div>
    </div>
  </section>
  );
};

export default ProductsSection; 